function initMainSwiperBoxes(root = document) {
  root.querySelectorAll('.main-swiper-wraper-box').forEach((wrapper) => {
    if (wrapper.classList.contains('predictive-search-products-slider')) return;
    if (wrapper.dataset.swiperInitialized === 'true') {
      return;
    }

    const sliderEl = wrapper.querySelector('.carousel-slider-product');
    const progressBar = wrapper.querySelector('.progress-bar-customer');

    if (!sliderEl) {
      return;
    }

    // Count the number of slides
    const slides = sliderEl.querySelectorAll('.swiper-slide');
    const slideCount = slides.length;
    const enableMousewheel = slideCount >= 4;

    const productSwiper = new Swiper(sliderEl, {
      slidesPerView: 3,
      spaceBetween: 0,
      loop: false,
      navigation: {
        nextEl: wrapper.querySelector('.next-button'),
        prevEl: wrapper.querySelector('.prev-button'),
      },
      mousewheel: {
        enabled: enableMousewheel,
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: false,
      },
      breakpoints: {
        768: { slidesPerView: 3, spaceBetween: 0 },
        580: { slidesPerView: 2.5 },
        350: { slidesPerView: 2.5 },
      },
      on: {
        init: function () {
          if (progressBar) updateProgress(this, progressBar);
        },
        slideChange: function () {
          if (progressBar) updateProgress(this, progressBar);
        },
        resize: function () {
          if (progressBar) updateProgress(this, progressBar);
        },
      },
    });

    if (progressBar) {
      progressBar.addEventListener('input', function () {
        const totalSlides = productSwiper.slides.length;
        const slidesPerView = productSwiper.params.slidesPerView;
        let steps = totalSlides - slidesPerView + 1;
        if (steps < 1) steps = 1;

        const targetStep = Math.round((this.value / 100) * (steps - 1));
        productSwiper.slideTo(targetStep);
      });
    }

    wrapper.querySelectorAll('svg').forEach((svg) => {
      svg.querySelectorAll('*').forEach((el) => {
        if (el.hasAttribute('stroke')) {
          el.setAttribute('stroke', '#002F6C');
        }
      });
    });

    wrapper.dataset.swiperInitialized = 'true';
  });

  function updateProgress(swiperInstance, progressEl) {
    if (!progressEl) return;
    const totalSlides = swiperInstance.slides.length;
    const slidesPerView = swiperInstance.params.slidesPerView;
    let steps = totalSlides - slidesPerView + 1;
    if (steps < 1) steps = 1;

    const currentStep = swiperInstance.activeIndex;
    const progress = (currentStep / (steps - 1)) * 100;
    progressEl.value = progress;
  }
}

window.initMainSwiperBoxes = initMainSwiperBoxes;

document.addEventListener('DOMContentLoaded', function () {
  initMainSwiperBoxes();

  var progressBarCard = document.querySelector('.progress-bar-card');
  var cardSwiper = new Swiper('.flex-row-three', {
    slidesPerView: 3,
    spaceBetween: 29,
    speed: 400,
    navigation: {
      nextEl: '.card-swiper-next',
      prevEl: '.card-swiper-prev',
    },
    mousewheel: {
      enabled: true,
      forceToAxis: true,
      sensitivity: 1,
      releaseOnEdges: false,
    },
    breakpoints: {
      0: { slidesPerView: 1.19, spaceBetween: 20 },
      650: { slidesPerView: 2, spaceBetween: 15 },
      992: { slidesPerView: 2.5, spaceBetween: 15 },
      1200: { slidesPerView: 3, spaceBetween: 29 },
    },
    on: {
      init: function () { updateProgress(this); },
      slideChange: function () { updateProgress(this); },
      resize: function () { updateProgress(this); }
    }
  });

  function updateProgress(swiperInstance) {
    if (!progressBarCard) return;
    var totalSlides = swiperInstance.slides.length;
    var slidesPerView = swiperInstance.params.slidesPerView;
    var steps = totalSlides - slidesPerView + 1;
    if (steps < 1) steps = 1;

    var currentStep = swiperInstance.activeIndex;
    var progress = (currentStep / (steps - 1)) * 100;
    progressBarCard.value = progress;
  }

  if (progressBarCard) {
    progressBarCard.addEventListener('input', function () {
      var totalSlides = cardSwiper.slides.length;
      var slidesPerView = cardSwiper.params.slidesPerView;
      var steps = totalSlides - slidesPerView + 1;
      if (steps < 1) steps = 1;

      var targetStep = Math.round((this.value / 100) * (steps - 1));
      cardSwiper.slideTo(targetStep);
    });
  }
});


/* home-page-collection-slider  */


document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.home-page-collection-swiper', {
    slidesPerView: 2.35,
    spaceBetween: 40,
    loop: false,
    navigation: {
      nextEl: '.swiper-next-col',
      prevEl: '.swiper-prev-col',
    },
    mousewheel: {
      enabled: true,
      forceToAxis: true,
      sensitivity: 1,
      releaseOnEdges: false,
    },
    breakpoints: {
      320: { slidesPerView: 1.75, spaceBetween: 10 },
      540: { slidesPerView: 2.5, spaceBetween: 20 },
      768: { slidesPerView: 2.5, spaceBetween: 20 },

      950: { slidesPerView: 3.15, spaceBetween: 20 },
      1024: { slidesPerView: 3.20, spaceBetween: 20 },
      1025: { slidesPerView: 1.6, spaceBetween: 30 },

      1200: { slidesPerView: 2.35, spaceBetween: 20 },

    },
  });

  const nextButton = document.querySelector('.next-slide-item');
  if (nextButton) {
    nextButton.addEventListener('click', function () {
      swiper.slideNext();
    });
  }

});


/* customer review */

document.addEventListener('DOMContentLoaded', function () {
  var progressBarCustomer = document.querySelector('.progress-bar-customer');
  var customerSwiper = new Swiper('.customerSwiper', {
    slidesPerView: 3.10,
    spaceBetween: 30,
    speed: 400,
    navigation: {
      nextEl: '.customer-swiper-next',
      prevEl: '.customer-swiper-prev',
    },
    mousewheel: {
      enabled: true,
      forceToAxis: true,
      sensitivity: 1,
      releaseOnEdges: false,
    },
    breakpoints: {
      0: { slidesPerView: 1.5, spaceBetween: 20 },
      576: { slidesPerView: 2.5, spaceBetween: 15 },
      992: { slidesPerView: 3, spaceBetween: 15 },
      1200: { slidesPerView: 3.10, spaceBetween: 20 },
      1350: { slidesPerView: 3.10, spaceBetween: 30 },
    },
    on: {
      init: function () { updateProgress(this); },
      slideChange: function () { updateProgress(this); },
      resize: function () { updateProgress(this); }
    }
  });

  function updateProgress(swiperInstance) {
    if (!progressBarCustomer) return;
    var totalSlides = swiperInstance.slides.length;
    var slidesPerView = swiperInstance.params.slidesPerView;
    var steps = totalSlides - slidesPerView + 1;
    if (steps < 1) steps = 1;

    var currentStep = swiperInstance.activeIndex;
    var progress = (currentStep / (steps - 1)) * 100;

    progressBarCustomer.value = progress;
  }

  if (progressBarCustomer) {
    progressBarCustomer.addEventListener('input', function () {
      var totalSlides = customerSwiper.slides.length;
      var slidesPerView = customerSwiper.params.slidesPerView;
      var steps = totalSlides - slidesPerView + 1;
      if (steps < 1) steps = 1;

      var targetStep = Math.round((this.value / 100) * (steps - 1));
      customerSwiper.slideTo(targetStep);
    });
  }
});



/* information grid-globle */

document.addEventListener('DOMContentLoaded', function () 
{
  var progressBar = document.querySelector('.progress-bar1');
  var swiper = new Swiper('.information-grid-swiper', {
    slidesPerView: 4,
    spaceBetween: 20,
    speed: 400,
    mousewheel: {
      enabled: true,
      forceToAxis: true,
      sensitivity: 1,
      releaseOnEdges: false,
    },
    breakpoints: {
      0: { slidesPerView: 1.15, spaceBetween:20 },
      576: { slidesPerView: 2.5, spaceBetween: 15 },
      992: { slidesPerView: 3, spaceBetween: 20 },
      1200: { slidesPerView: 4, spaceBetween: 20 },
    },
    on: {
      init: function () { updateProgress(this); },
      slideChange: function () { updateProgress(this); },
      resize: function () { updateProgress(this); }
    }
  });
  function updateProgress(swiperInstance) {
    if (!progressBar) return;
    var totalSlides = swiperInstance.slides.length;
    var slidesPerView = swiperInstance.params.slidesPerView;
    var steps = totalSlides - slidesPerView + 1;
    if (steps < 1) steps = 1;

    var currentStep = swiperInstance.activeIndex;
    var progress = (currentStep / (steps - 1)) * 100;

    progressBar.value = progress;
  }
  if (progressBar) {
    progressBar.addEventListener('input', function () {
      var totalSlides = swiper.slides.length;
      var slidesPerView = swiper.params.slidesPerView;
      var steps = totalSlides - slidesPerView + 1;
      if (steps < 1) steps = 1;

      var targetStep = Math.round((this.value / 100) * (steps - 1));
      swiper.slideTo(targetStep);
    });
  }
});
    